<div *ngIf="!componentRef" class="d-flex justify-content-center px-3 py-5 LearnModulesOverlay">
  <div class="awaiting-state text-center">
    <!-- <p class="awaiting-state__icon-title font-14"><strong>Module 1- Trust Equation</strong></p> -->
    <h6 class="awaiting-state__title mg-b30 font-20"><strong>{{exerciseDetails?.title}}</strong></h6>
    <img class="awaiting-state__icon mg-b30" src="assets/images/success2.png" alt="">
    <!-- <p class="awaiting-state__icon-title mg-b40">Exercise Completed</p> -->
    <h6 class="awaiting-state__title mg-b30 font-20">{{ isMuteScores ? "Feedback" : "Score" }} Awaited</h6>
    <!-- <div class="awaiting-state__alert mg-b10">Your test is currently being evaluated by Mr XYZ</div> -->
    <p class="awaiting-state__desc font-14 lh-24 mg-b0"><strong class="font-14">Harappa Learning Specialists are
        reviewing your responses.</strong></p>
    <p class="awaiting-state__desc font-14 lh-24 mg-b0">You will receive an email when the {{ isMuteScores ? "analysis" : "grading" }}  is complete.</p>
    <p class="awaiting-state__desc font-14 lh-24 mg-b30">Submitted On :
      {{_attemptedExercise?.dateOfSubmission | date:"dd MMM yyy, h:mm a"}} </p>
    
    <!-- <h3 *ngIf="timeLeft>0" class="awaiting-state__time">{{timeLeft}} {{timeLeft == 1 ?'Hr':'Hrs'}}</h3> -->
    <hr class="mg-b30">
    <!-- <button (click)="seeExerciseResult()" type="button" class="btn  btn-outline-primary mg-r10 mg-l10 mg-b10 long-btn30"><span>See Responses</span></button> -->
    <button (click)="next()" type="button"
      class="btn btn-primary long-btn30 mg-r10 mg-l10 mg-b10"><span>Next</span></button>
  </div>
</div>
<ng-template #result>
</ng-template>
